import { Phone, MapPin, Clock, Calendar, ArrowRight, User } from "lucide-react";

const POINTS = [
  {
    city: "FETEȘTI",
    badge: "01 / SEDIUL PRINCIPAL",
    person: "Alina Gheorghe",
    phone: "0766 693 105",
    phoneRaw: "0766693105",
    address: "Zona Industrială 804",
    region: "Fetești, Județul Ialomița",
  },
  {
    city: "SLOBOZIA",
    badge: "02 / PUNCT DE LUCRU",
    person: "Smău Vasile",
    phone: "0722 569 492",
    phoneRaw: "0722569492",
    address: "Șoseaua Brăilei nr. 25E",
    region: "Zona Industrială Nord-Est, Municipiul Slobozia",
  },
];

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="py-20 sm:py-32 bg-white border-t border-black/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#F59E0B] mb-6">
              · 05 / CONTACT
            </div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tight">
              Sună pentru<br />
              <span className="text-[#F59E0B]">comandă</span> & ofertă.
            </h2>
          </div>
          <p className="max-w-md text-sm sm:text-base text-neutral-700 leading-relaxed">
            Comenzile, prețurile, tipurile de beton și programările se stabilesc
            <span className="font-bold text-black"> exclusiv telefonic</span>, în programul de lucru — Luni-Vineri, 08:00-17:00.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {POINTS.map((p) => (
            <div
              key={p.city}
              data-testid={`contact-card-${p.city.toLowerCase()}`}
              className="bg-[#FAFAFA] border border-black/15 p-8 sm:p-10 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[#F59E0B]">
                  · {p.badge}
                </span>
                <MapPin className="w-4 h-4 text-neutral-400" strokeWidth={2} />
              </div>

              <div className="font-display text-5xl sm:text-6xl uppercase leading-none tracking-tight mt-6 text-black">
                {p.city}
              </div>

              <div className="mt-6 pt-6 border-t border-black/10 space-y-5">
                <Row icon={User} label="Persoană contact" value={p.person} />
                <a
                  href={`tel:${p.phoneRaw}`}
                  data-testid={`contact-phone-${p.city.toLowerCase()}`}
                  className="block group"
                >
                  <div className="flex items-start gap-3">
                    <Phone className="w-4 h-4 text-[#F59E0B] flex-shrink-0 mt-1.5" strokeWidth={2.5} />
                    <div>
                      <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-500">
                        Telefon
                      </div>
                      <div className="font-display text-2xl sm:text-3xl uppercase tracking-tight leading-none mt-1.5 group-hover:text-[#F59E0B] transition-colors">
                        {p.phone}
                      </div>
                    </div>
                  </div>
                </a>
                <Row icon={MapPin} label="Adresă" value={p.address} sub={p.region} />
                <Row icon={Clock} label="Program" value="Luni — Vineri" sub="08:00 — 17:00" />
              </div>

              <a
                href={`tel:${p.phoneRaw}`}
                data-testid={`contact-cta-${p.city.toLowerCase()}`}
                className="btn-amber rounded-sm inline-flex items-center justify-center gap-2 px-5 py-3.5 text-sm font-bold uppercase tracking-wider mt-8"
              >
                <Phone className="w-4 h-4" strokeWidth={2.5} />
                Sună la {p.city}
              </a>
            </div>
          ))}
        </div>

        <div className="mt-8 flex items-start gap-3 p-4 border-l-2 border-[#F59E0B] bg-[#FAFAFA]">
          <Calendar className="w-4 h-4 text-[#F59E0B] flex-shrink-0 mt-0.5" />
          <p className="font-mono-tech text-[11px] sm:text-xs tracking-[0.15em] uppercase text-neutral-700 leading-relaxed">
            Reținere: comenzile se fac cu minim 48 de ore înainte de data turnării.
          </p>
        </div>
      </div>
    </section>
  );
}

function Row({ icon: Icon, label, value, sub }) {
  return (
    <div className="flex items-start gap-3">
      <Icon className="w-4 h-4 text-neutral-500 flex-shrink-0 mt-1.5" strokeWidth={2} />
      <div>
        <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-500">{label}</div>
        <div className="font-display text-lg sm:text-xl uppercase tracking-tight leading-none mt-1.5 text-black">
          {value}
        </div>
        {sub && <div className="text-xs sm:text-sm text-neutral-600 mt-1.5">{sub}</div>}
      </div>
    </div>
  );
}
